import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { SYS_ENV } from '../../../enum/analytics.enum';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  constructor(private observer: BreakpointObserver) {}

  getDeviceType(): string {
    if (this.observer.isMatched(Breakpoints.HandsetPortrait)) return SYS_ENV.M;
    if (this.observer.isMatched(Breakpoints.TabletPortrait)) return SYS_ENV.T;
    return SYS_ENV.D;
  }
}
